module.exports = __webpack_public_path__ + "assets/img/61a5c35b048ebeb5a3a7b26afc18c4c3.svg";